import {merge, get, map} from 'lodash';
import moment from 'moment';
import {inlineSchema} from './utils';
import i18n from 'src/i18n';
import * as Group from './group';

export default function () {
  return {

    product_id: {type: 'id', required: true},
    created_at: {type: 'datetime', readonly: true},

    //  status :
    //  inactive : admin can't see and can't buy
    //  suspended : client can't order, admin can see
    privacy: {type: 'number', list: false}, // `1== published, 100 == admin only
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'}, // can be ordered
    type: {type: 'string', default: 'published'},
    tags: {type: 'tags', hidden: false, list: true},

    details: {
      expand: true,
      type: 'schema', schema: inlineSchema({
        title: {type: 'i18n', itemType: {type: 'string'}},
        description: {type: 'i18n', itemType: {type: 'text'}},
        days_to_expiry: {type: 'number'}, //  okcare ticket life span
      }),
    },

    //  basic item
    // item: {type: Schema.Types.ObjectId, ref: 'items', required: true},
    //  custom choices
    required_custom_types: {type: 'select', items: ['fields.timeslot', 'fields.feature'], multi: true, list: false}, //  ['color', 'hours'] ** Good!!

    customs: {
      label: 'fields.timeslots',
      type: 'array', add: true, delete: true, itemType: {
        type: 'schema', schema: merge(inlineSchema({
          custom_id: {
            type: 'id', required: true, readonly: true,
            get(model) {
              return i18n.nn`${get(model, 'details.service_hours', 0) * 60}-${moment(get(model, 'details.start_time')).format('HHmm')}-${get(model, 'details.cooldown_hours', 0) * 60}`;
            },
          }, // if time-slot, timeslot_id, else custom_id
          type: {type: 'select', items: ['fields.timeslot', 'fields.feature'], required: true}, //  mutually exclusive, e.g. can only customise once // eg. "time-slot" or "features"
          details: {
            type: 'schema', expand: true,
            schema: inlineSchema({
              service_hours: {
                type: 'number', required: true, min: 0,
              },
              start_time: {
                type: 'time', required: true,
              },
              cooldown_hours: {
                type: 'number', required: true, min: 0,
              },
              description: {type: 'string'},
            }),
          },
          price_options: {
            type: 'array', add: true, delete: true, min: 1, max: 1, itemType: {
              type: 'schema', expand: true,
              schema: merge(inlineSchema({
                currency_type: {
                  type: 'select',
                  items: ['fields.currency.cash_hkd', 'fields.currency.cash_rmb'],
                },
                currency_amount: {type: 'number'},
                caregiver_commission: {type: 'number'},
              }), {
                title(model) {
                  return i18n.nn`${model.currency_type}: ${model.currency_amount}`;
                },
              }),
            },
          },
        }), {
          title(model) {
            if (model && model.custom_id) {
              let parts = model.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '');
              parts = parts.split('-');
              let start = moment(parts[1], 'HHmm');
              return `${moment.duration(parseInt(parts[0]), 'm').humanize()}, ${start.format('HH:mm')}~${start.add(parseInt(parts[0]), 'm').format('HH:mm')}, cool down ${moment.duration(parseInt(parts[2]), 'm').humanize()}`;
            } else {
              return '';
            }
          },
        }),
      },
    },
    //  additional items associated with basic item
    // additional_items: [{
    //   item: {type: Schema.Types.ObjectId, ref: 'items', required: true},
    //   price_options: [{
    //     currency_type: {type: String}, // diamond / usd / hkd / ...
    //     currency_amount: {type: Number}
    //   }]
    // }],


    required_groups: {
      type: 'array', add: true, delete: true, itemType: {
        type: 'schema', schema: merge(inlineSchema({
          group: {
            type: 'select', search: true, valueKey: 'group_id',
            items(value, model, fieldSpec, search) {
              return Group.list.call(this, {skip: 0, limit: -1, search, status: 'active'})
                .then(response => {
                  return map(response.data, x => ({value: x, label: i18n.S(get(x, 'details.name'))}));
                });
            },
          },
          required_self_status: {type: 'select', items: ['status.pending', 'status.approved', 'status.admin']},
        }), {
          title(model) {
            return Group.title.call(this, model.group, Group);
          },
        }),
      },
    },


    inventory_unlimited: {type: Boolean, list: false}, //    deduct inventory of the product created
    inventory: {type: 'number', default: -1, list: false},

    // price_options: {
    //   type: 'array', add: true, delete: true, min: 1, max: 1, itemType: {
    //     type: 'schema', schema: inlineSchema({
    //       currency_type: {
    //         type: 'select',
    //         items: ['fields.currency.cash_hkd', 'fields.currency.cash_usd'],
    //       },
    //       currency_amount: {type: 'number'},
    //     }),
    //   },
    // },
  };
}



// WEBPACK FOOTER //
// ./src/schemas/product_db.js